import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { login } from '../../store/slices/auth';
import { useNavigate } from 'react-router-dom';
import { axiosApi } from "config";

const GoogleAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSuccess = async (credentialResponse) => {
    try {
      const { credential } = credentialResponse;
      if (!credential) {
        toast.error("Google authentication failed.");
        return;
      }

      const res = await axiosApi.post("/auth/google", { idToken: credential }, { withCredentials: true });
      const { token, user, platforms } = res.data.data;

      // Save token to local storage
      localStorage.setItem("Riplestack_info", token);

      // Set token in Axios headers
      axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // Dispatch login action to Redux
      dispatch(login({ token, user, platforms }));

      // Notify user and navigate
      toast.success("Logged in with Google!");
      console.log("Navigating to /main/default");
      navigate("/main/default", { replace: true });
    } catch (error) {
      console.error("Google Login Error:", error);
      toast.error("Google login failed. Please try again.");
    }
  };

  const handleError = () => {
    toast.error("Google authentication failed.");
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      useOneTap
    />
  );
};

export default GoogleAuth;
